import { connect } from 'react-redux';
import DigitalShelf from '../../../../components/features/digitalShelf/DigitalShelf';

export default connect(state => ({
}), {

})(DigitalShelf);
